import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class TimetableSearchForm extends Component {
	constructor(props) {
		super(props);
	}
	
	render() {
		const { cities, centers, selectedCity, selectedCenter, franchisorDisplayName, t } = this.props;

		const cityCenters = selectedCity ? centers.filter(x => x.city === selectedCity) : centers;

		return <div>
			<h3>{franchisorDisplayName && `${franchisorDisplayName}: `}{t('FO_IndividualConsultationSearch_InfoMessage')}</h3>
			<div className='info-message' dangerouslySetInnerHTML={{ __html: t('FO_IndividualConsultationSearch_InfoMessage_html') }} />
			<ButtonToolbar className='timetable-search'>
				<DropdownButton id='timetableSearchCity' onSelect={key => this.props.onSelectCity(key)}
					className='btn-block-xxs'
					bsStyle={selectedCity ? 'primary' : 'default'}
					title={selectedCity ? selectedCity : t('FO_TimetableSearch_City')}
				>
					{cities.map(city => <MenuItem key={city} eventKey={city} >{city}</MenuItem>)}
				</DropdownButton>
				<DropdownButton id='timetableSearchCenter' onSelect={key => this.props.onSelectCenter(key)}
					className='btn-block-xxs'
					bsStyle={selectedCenter ? 'primary' : 'default'}
					title={selectedCenter ? selectedCenter.name : t('FO_TimetableSearch_Center')}
				>
					{cityCenters.map(center => <MenuItem key={center.id} eventKey={center.id} >{center.name}</MenuItem>)}
				</DropdownButton>
			</ButtonToolbar>
		</div>;
	}
}

TimetableSearchForm.propTypes = {
	franchisorDisplayName: PropTypes.string,
	cities: PropTypes.arrayOf(PropTypes.string),
	centers: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	})),
	selectedCity: PropTypes.string,
	selectedCenter: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	}),
	onSelectCity: PropTypes.func.isRequired,
	onSelectCenter: PropTypes.func.isRequired
};

export default withTranslation()(TimetableSearchForm);